'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    -webkit-appearance: none;\n    overflow: visible;\n    width: 100%;\n    background: transparent;\n    outline: none;\n\n    --min: ', ';\n    --max: ', ';\n    --value: ', ';\n    --range: calc(var(--max) - var(--min));\n    --ratio: calc((var(--value) - var(--min))/var(--range));\n    --sx: calc(.5*1.5em + var(--ratio)*(100% - 1.5em));\n\n    ::-webkit-slider-runnable-track {\n        -webkit-appearance: none;\n        background: linear-gradient(', ', ', ') 0/var(--sx) 100% no-repeat ', ';\n        height: 10px;\n        border-radius: ', ';\n      }\n\n    ::-webkit-slider-thumb {\n        -webkit-appearance: none;\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        background: ', ';\n        border: 2px solid ', ';\n        margin-top: -5px;\n     }\n\n    ::-moz-range-thumb {\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        background: ', ';\n        border: 2px solid ', ';\n        margin-top: -5px;\n    }\n\n   ::-moz-range-progress {\n        height: 10px;\n        border-radius: ', ';\n        background-color: ', '; \n      }\n\n    ::-moz-range-track {  \n        height: 10px;\n        border-radius: ', ';\n        background-color: ', ';\n      }\n'], ['\n    -webkit-appearance: none;\n    overflow: visible;\n    width: 100%;\n    background: transparent;\n    outline: none;\n\n    --min: ', ';\n    --max: ', ';\n    --value: ', ';\n    --range: calc(var(--max) - var(--min));\n    --ratio: calc((var(--value) - var(--min))/var(--range));\n    --sx: calc(.5*1.5em + var(--ratio)*(100% - 1.5em));\n\n    ::-webkit-slider-runnable-track {\n        -webkit-appearance: none;\n        background: linear-gradient(', ', ', ') 0/var(--sx) 100% no-repeat ', ';\n        height: 10px;\n        border-radius: ', ';\n      }\n\n    ::-webkit-slider-thumb {\n        -webkit-appearance: none;\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        background: ', ';\n        border: 2px solid ', ';\n        margin-top: -5px;\n     }\n\n    ::-moz-range-thumb {\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        background: ', ';\n        border: 2px solid ', ';\n        margin-top: -5px;\n    }\n\n   ::-moz-range-progress {\n        height: 10px;\n        border-radius: ', ';\n        background-color: ', '; \n      }\n\n    ::-moz-range-track {  \n        height: 10px;\n        border-radius: ', ';\n        background-color: ', ';\n      }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _label = require('../text/label');

var _label2 = _interopRequireDefault(_label);

var _header = require('../text/header');

var _header2 = _interopRequireDefault(_header);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _grid = require('../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _getColor = require('../../helpers/getColor');

var _getColor2 = _interopRequireDefault(_getColor);

var _colors = require('../../constants/colors');

var _opacity = require('../../constants/opacity');

var _opacity2 = _interopRequireDefault(_opacity);

var _radius = require('../../constants/radius');

var _sizes = require('../../constants/sizes');

var _alignments = require('../../constants/alignments');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SliderComponent = _styledComponents2.default.input(_templateObject, function (_ref) {
    var min = _ref.min;
    return '' + min;
}, function (_ref2) {
    var max = _ref2.max;
    return '' + max;
}, function (_ref3) {
    var value = _ref3.value;
    return '' + value;
}, function (_ref4) {
    var error = _ref4.error;
    return error ? _colors.Colors.Error : _colors.Colors.Primary;
}, function (_ref5) {
    var error = _ref5.error;
    return error ? _colors.Colors.Error : _colors.Colors.Primary;
}, function (_ref6) {
    var color = _ref6.color;
    return color === 'dual' ? _colors.Colors.Secondary : (0, _getColor2.default)(_colors.Colors.Secondary, _opacity2.default.Light);
}, _radius.Radius.large, _colors.Colors.Primary, _colors.Colors.LightMode, _colors.Colors.Primary, _colors.Colors.LightMode, _radius.Radius.large, function (_ref7) {
    var error = _ref7.error;
    return error ? _colors.Colors.Error : _colors.Colors.Primary;
}, _radius.Radius.large, function (_ref8) {
    var unit = _ref8.unit;
    return unit === '%' ? _colors.Colors.Secondary : _colors.Colors.StrokeLight;
});

var Slider = function (_React$Component) {
    _inherits(Slider, _React$Component);

    function Slider() {
        _classCallCheck(this, Slider);

        return _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).apply(this, arguments));
    }

    _createClass(Slider, [{
        key: 'getSlider',
        value: function getSlider() {
            var _this2 = this;

            var type = this.props.type;
            var unit = this.props.unit || '';
            var unitAlignment = this.props.unitAlignment || 'right';
            var header = this.props.header || false;
            var min = parseInt(this.props.min);
            var max = parseInt(this.props.max);
            var labelL = this.props.leftLabel;
            var labelR = this.props.rightLabel;
            var increment = this.props.increment || 1;
            var valSeparator = this.props.valueSeparator || false;
            var value = this.props.value || min || 0;

            var displayValue = value;
            var minLabelText = min || 0;
            var maxLabelText = max || 100;

            var narrow = this.props.narrow || false;

            if (type === 'ratio') {
                unit = '%';
            }

            if (increment >= max) {
                increment = 1;
            }

            if (valSeparator) {
                displayValue = displayValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                minLabelText = minLabelText.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                maxLabelText = maxLabelText.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }

            if (unitAlignment === 'right') {
                minLabelText = minLabelText + ' ' + unit;
                maxLabelText = maxLabelText + ' ' + unit;
            } else {
                minLabelText = unit + ' ' + minLabelText;
                maxLabelText = unit + ' ' + maxLabelText;
            }

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                header && _react2.default.createElement(
                    _row2.default,
                    { nogutter: true },
                    _react2.default.createElement(
                        _column2.default,
                        { xs: 6, nogutterleft: true, nogutterright: true },
                        unitAlignment === 'right' ? _react2.default.createElement(_header2.default, { bold: true, size: _sizes.Sizes.md, textAlign: _alignments.Alignments.left, color: _colors.Colors.Primary, text: (displayValue || '0') + ' ' + unit }) : _react2.default.createElement(_header2.default, { bold: true, size: _sizes.Sizes.md, textAlign: _alignments.Alignments.left, color: _colors.Colors.Primary, text: unit + ' ' + (displayValue || '0') })
                    ),
                    type === 'ratio' && _react2.default.createElement(
                        _column2.default,
                        { xs: 6, nogutterleft: true, nogutterright: true },
                        _react2.default.createElement(_header2.default, { bold: true, size: _sizes.Sizes.md, textAlign: _alignments.Alignments.right, color: _colors.Colors.Secondary, text: (100 - value || '0') + ' ' + unit })
                    )
                ),
                _react2.default.createElement(
                    _row2.default,
                    { nogutter: narrow },
                    _react2.default.createElement(
                        _column2.default,
                        { nogutterleft: true, nogutterright: true },
                        type === 'ratio' ? _react2.default.createElement(SliderComponent, {
                            type: 'range',
                            min: 0,
                            max: 100,
                            step: '' + increment,
                            onInput: function onInput(e) {
                                var value = e.target.value;
                                var limit = min || 0;
                                if (value >= limit) {
                                    _this2.props.changeEvent(value);
                                }
                            },
                            value: value || 0,
                            error: this.props.error,
                            color: 'dual' }) : _react2.default.createElement(SliderComponent, {
                            type: 'range',
                            min: min,
                            max: max,
                            step: '' + increment,
                            onInput: function onInput(e) {
                                _this2.props.changeEvent(e.target.value);
                            },
                            value: value || min,
                            error: this.props.error
                        })
                    )
                ),
                _react2.default.createElement(
                    _row2.default,
                    { nogutter: true },
                    type === 'ratio' && labelL && labelR ? _react2.default.createElement(
                        _row2.default,
                        { nogutter: true },
                        _react2.default.createElement(
                            _column2.default,
                            { xs: 6, nogutterleft: true, nogutterright: true },
                            _react2.default.createElement(
                                _container2.default,
                                { fullSize: true },
                                _react2.default.createElement(_label2.default, { size: _sizes.Sizes.md,
                                    text: '' + labelL,
                                    textAlign: _alignments.Alignments.left
                                })
                            )
                        ),
                        _react2.default.createElement(
                            _column2.default,
                            { xs: 6, nogutterleft: true, nogutterright: true },
                            _react2.default.createElement(
                                _container2.default,
                                { fullSize: true },
                                _react2.default.createElement(_label2.default, { size: _sizes.Sizes.md,
                                    text: '' + labelR,
                                    textAlign: _alignments.Alignments.right
                                })
                            )
                        )
                    ) : _react2.default.createElement(
                        _row2.default,
                        { nogutter: true },
                        _react2.default.createElement(
                            _column2.default,
                            { xs: 6, nogutterleft: true, nogutterright: true },
                            _react2.default.createElement(
                                _container2.default,
                                { fullSize: true },
                                _react2.default.createElement(_label2.default, { size: _sizes.Sizes.md,
                                    text: '' + minLabelText,
                                    textAlign: _alignments.Alignments.left
                                })
                            )
                        ),
                        _react2.default.createElement(
                            _column2.default,
                            { xs: 6, nogutterleft: true, nogutterright: true },
                            _react2.default.createElement(
                                _container2.default,
                                { fullSize: true },
                                _react2.default.createElement(_label2.default, { size: _sizes.Sizes.md,
                                    text: '' + maxLabelText,
                                    textAlign: _alignments.Alignments.right
                                })
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var narrow = this.props.narrow || false;
            return _react2.default.createElement(
                _grid2.default,
                null,
                this.props.fullSize ? this.getSlider() : _react2.default.createElement(
                    _column2.default,
                    { md: 6, nogutterleft: true, nogutterright: true },
                    this.getSlider()
                )
            );
        }
    }]);

    return Slider;
}(_react2.default.Component);

exports.default = Slider;